import ParticipantNotes from './ParticipantNotes';

export default ParticipantNotes;
